/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signing_OutInputs */

const th_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังออกจากระบบ…`)
};

const en_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing out…`)
};

const ja_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウトしています…`)
};

const zh_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在登出…`)
};

const es_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrando sesión…`)
};

const pt_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saindo…`)
};

const id_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keluar…`)
};

const fr_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déconnexion…`)
};

const tl_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagsi-sign out…`)
};

const vi_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang đăng xuất…`)
};

const ko_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그아웃 중…`)
};

const de_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird abgemeldet…`)
};

const ru_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выходим…`)
};

const tr_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çıkış yapılıyor…`)
};

const it_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disconnessione…`)
};

const pl_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wylogowywanie…`)
};

const uk_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виходимо…`)
};

const hi_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साइन आउट हो रहा है…`)
};

const ar_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تسجيل الخروج…`)
};

const ms_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedang log keluar…`)
};

const bn_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাইন আউট হচ্ছে…`)
};

const zh_tw2_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出中…`)
};

const zh_hk2_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登出中…`)
};

const ur_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سائن آؤٹ ہو رہا ہے…`)
};

const fa_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال خروج…`)
};

const sw_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inatoka…`)
};

const nl_signing_out = /** @type {(inputs: Signing_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezig met uitloggen…`)
};

/**
* | output |
* | --- |
* | "Signing out…" |
*
* @param {Signing_OutInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const signing_out = /** @type {((inputs?: Signing_OutInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signing_OutInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_signing_out(inputs)
	if (locale === "ja") return ja_signing_out(inputs)
	if (locale === "zh") return zh_signing_out(inputs)
	if (locale === "es") return es_signing_out(inputs)
	if (locale === "pt") return pt_signing_out(inputs)
	if (locale === "id") return id_signing_out(inputs)
	if (locale === "fr") return fr_signing_out(inputs)
	if (locale === "tl") return tl_signing_out(inputs)
	if (locale === "vi") return vi_signing_out(inputs)
	if (locale === "ko") return ko_signing_out(inputs)
	if (locale === "de") return de_signing_out(inputs)
	if (locale === "ru") return ru_signing_out(inputs)
	if (locale === "tr") return tr_signing_out(inputs)
	if (locale === "it") return it_signing_out(inputs)
	if (locale === "pl") return pl_signing_out(inputs)
	if (locale === "uk") return uk_signing_out(inputs)
	if (locale === "hi") return hi_signing_out(inputs)
	if (locale === "ar") return ar_signing_out(inputs)
	if (locale === "ms") return ms_signing_out(inputs)
	if (locale === "bn") return bn_signing_out(inputs)
	if (locale === "zh-TW") return zh_tw2_signing_out(inputs)
	if (locale === "zh-HK") return zh_hk2_signing_out(inputs)
	if (locale === "ur") return ur_signing_out(inputs)
	if (locale === "fa") return fa_signing_out(inputs)
	if (locale === "sw") return sw_signing_out(inputs)
	if (locale === "nl") return nl_signing_out(inputs)
	return en_signing_out(inputs)
});